"use client";

import Button from "@/components/design-system/button";
import Modal from "@/components/design-system/modal";
import { useAppSelector } from "@/store/hooks";
import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import styles from "./takeDownRequests.module.scss";

export default function TakeDownRequestsModal({ showTakeDownModal, setShowTakeDownModal }: TakeDownRequestsProps) {
  const [googleRecaptchaCompleted, setGoogleRecaptchaCompleted] = useState(false);
  const googleRecaptchaApiKey = useAppSelector((state) => state.config.googleRecaptchaV1);
  const formRef = useRef<HTMLFormElement>(null);

  if (!googleRecaptchaApiKey) return null;

  const hide = () => {
    setGoogleRecaptchaCompleted(false);
    setShowTakeDownModal(false);
  };

  return (
    <Modal
      show={showTakeDownModal}
      onHide={hide}
      title="Takedown Request"
      size="skinny"
      sizeDownMd="medium"
      footer={
        <>
          <Button
            variant="secondary"
            color="blue"
            text="Cancel"
            showLeftIcon={false}
            showRightIcon={false}
            onClick={hide}
            data-takedown-request-cancel=""
          />
          <Button
            variant="primary"
            color="blue"
            text="Continue"
            showLeftIcon={false}
            showRightIcon={false}
            disabled={!googleRecaptchaCompleted}
            onClick={() => formRef.current?.requestSubmit()}
            data-takedown-request-continue=""
          />
        </>
      }
    >
      <form
        ref={formRef}
        className={styles.TakeDownRequestsForm}
        data-takedown-request-form=""
        action="/takedown-request"
        method="POST"
      >
        <p className={styles.message}>
          Net32 respects the intellectual property rights of others. If you believe your rights have been violated by
          any content or product featured on our platform, you may provide us with a notice of infringement by
          completing our <strong>Takedown Request</strong> form. If you proceed to our form, please be sure to complete
          all required fields clearly and accurately, including your contact information and information regarding the
          alleged infringement. An incomplete or ambiguous notice may prevent Net32 from thoroughly investigating and
          quickly resolving the issue you raise.
        </p>
        <p className={styles.question}>Do you wish to continue to Net32&apos;s Takedown Request form?</p>
        <ReCAPTCHA
          sitekey={googleRecaptchaApiKey}
          onChange={(token) => setGoogleRecaptchaCompleted(Boolean(token))}
          onExpired={() => setGoogleRecaptchaCompleted(false)}
        />
      </form>
    </Modal>
  );
}

export type TakeDownRequestsProps = {
  showTakeDownModal: boolean;
  setShowTakeDownModal: (val: boolean) => void;
};
